// extracted by mini-css-extract-plugin
export var noSpinners = "_st-6";
export var percentageInput = "_st-7";
export var variantColor1 = "_st-0";
export var variantColor2 = "_st-1";
export var variantColor3 = "_st-2";
export var variantColor4 = "_st-3";
export var variantColor5 = "_st-4";
export var variantColor6 = "_st-5";